/**
 * DataFreshnessChip - compact "forecast valid HH:MM" summary for active
 * weather/model layers (wind, air quality, lightning risk, fire danger).
 *
 * Rendered as a small non-interactive chip in the bottom-left of both the
 * 2D and 3D maps. Only appears when at least one model layer has reported
 * its validity via reportLayerFreshness(); disabled layers clear their
 * entry so the chip shrinks/disappears with them.
 */

import { useLayerFreshness } from '../utils/layerFreshness';

function formatValidTime(iso: string): string {
  const date = new Date(iso);
  if (isNaN(date.getTime())) return '—';
  return date.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
}

export default function DataFreshnessChip() {
  const layers = useLayerFreshness();

  if (layers.size === 0) return null;

  const parts = Array.from(layers.values()).map(
    (entry) => `${entry.label} ${formatValidTime(entry.validTime)}`
  );

  return (
    <div
      style={{
        position: 'absolute',
        bottom: '22px',
        left: '10px',
        zIndex: 1000,
        pointerEvents: 'none',
        padding: '3px 8px',
        borderRadius: '6px',
        backgroundColor: 'var(--bg-secondary, rgba(17, 24, 39, 0.75))',
        color: 'var(--text-secondary, #9ca3af)',
        fontSize: '12px',
        lineHeight: '1.4',
        maxWidth: 'calc(100% - 20px)',
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
      }}
      title="Model data valid for the hour shown (updated hourly from the latest forecast run)"
      aria-label={`Forecast data valid: ${parts.join(', ')}`}
    >
      Forecast valid: {parts.join(' · ')}
    </div>
  );
}
